define('responsive-game-feed/app/scripts/utils/Utils',['require','exports','module','moment','./logger','jpath/jpath','gameday-language/gameday-language','gameday-language/translator'],function (require, exports, module) {
    var moment = require("moment"),
        logg = require( "./logger" ),
        Jpath = require( "jpath/jpath" ),
        gamedayLanguage = require("gameday-language/gameday-language");
        translator = require("gameday-language/translator");
        
        var count = 1;
        
    
    var Utils = {
        env: function () {
            // return beta|qa|prod
            var e = (window.location.hostname.indexOf("beta") >= 0 ) ? "beta" : ( (window.location.hostname.indexOf("qa") >= 0 || window.location.hostname.indexOf("dev") >= 0) ? "qa" : "prod");
            var d = (e == "beta") ? "http://beta.mlb.com" : ((e == "qa") ? "http://qa.mlb.com" : "http://mlb.com");
            return {
                env: e,
                domain: d
            }
        },
        options: null,
        debugMode: false,
        gameState: null,
        gameType: null,
        gameIsLive: function () {
            if (this.gameState === null) { return; }
            var isLive = 0,
                stateMap = {

                    //Pregame
                    X: 0,
                    C: 0,
                    D: 0,
                    S: 0,
                    P: 0,
                    // In game - but suspended
                    T: 0,
                    U: 0,
                    //In game
                    M: 1,
                    N: 1,
                    I: 1,
                    //Wrapup
                    O: 0,
                    F: 0,
                    Q: 0,
                    R: 0,
                    W: 0
                }
            var ind = this.gameState.charAt(0);
            isLive = stateMap[ind] || isLive;
            return isLive;
        },
        log: function (msg) {
            logg.log.apply(logg,arguments);
        },
        getImageByType: function (thumbs, type) {
            var defaultImg;
            var t = thumbs.filter(function(thumb) {
               
               if (parseFloat(thumb.type) === 22) {
                 defaultImg = thumb;
               }
               
               return parseFloat(thumb.type) == parseFloat(type)
            });
            
            return (t.length === 0) ? defaultImg._ : t[0]._;
        },
        sendMessage: function (msg) {
            if (window.parent) {
                window.parent.postMessage("cf:" + msg, '*');
            }
        },
        
        getNewFeedEntries: function(data) {
           //var sorted_arr = data.sort(function(a,b) { return (a.data.guid === b.data.guid); } );
        },
        
        getLanguage: function() {
           if (this.options.language) {
             return this.options.language;
           }
           
           var docroot=document.documentElement;
           this.options.language = Utils.options.language || window.navigator.userLanguage || window.navigator.language || (docroot && docroot.getAttribute('lang') || docroot.getAttribute('xml:lang'));
           return this.options.language;
        },
        
        formatTimestamp: function(time) {
          var timeArr = time.split("_");
          var yymmdd = timeArr[0];
          var hhmmss = timeArr[1];
          var yymmddMod = yymmdd.substr(0,4) + "/" + yymmdd.substr(4,2)  + "/" + yymmdd.substr(6,2);
          var hhmmssMod = hhmmss.substr(0,2) + ":" + hhmmss.substr(2,2)  + ":" + hhmmss.substr(4,2);
          
          m =  moment(yymmddMod  + " " + hhmmssMod);
          Utils.options.endTimecode = m.add("seconds", 10 * Utils.options.apiRequestCounts).format('YYYYMMDD_HHmmss');
          return Utils.options.endTimecode;      
        },
        
        
        
        insertItem: function(element,entry, html) {
          var totalEntries = $(".feed-item").not( ".error" );
          var insertBeforeDiv;
          var eid;
          
          if (totalEntries.length === 0) {
             element.prepend(html);
             
          } else {
            eid = entry.guid;
            
            $("#" + eid).attr("id", eid + "_removed");
            
               
            for (var i = 0; i < totalEntries.length; i++) {
              if (totalEntries[i].group !== 'scout') {
     
               var tempTimestamp = $(totalEntries[i]).attr("data-timegen").replace("_","");
               var timestamp = entry.time_gen.replace("_", "") * 1;
               
               
               if (tempTimestamp <= timestamp) {
                  insertBeforeDiv = $(totalEntries[i]).attr("id");
                  $("#" + insertBeforeDiv).parent().before(html);
                  $("#" + eid + "_removed").parent().remove();
                  
                  break;
               }
               
               }
               
            }
          
          }
        },
        
       
        sendPlayerMessage : function(cfg) {
          var pid = cfg.target.attr("href").split('=')[1];
          var decode = translator(Utils.options.language,true);
          var data = {
            title : decode.translate("Player Card"),
            pid : pid,
            url : (Utils.options.language === "es") ? "http://m."+Utils.options.language+".mlb.com/gameday/player/"+ pid : "http://m.mlb.com/gameday/player/"+ pid
          };
          
           if(Utils.options.deviceInteraction.playercard(data)){
                cfg.event.preventDefault();
                cfg.event.stopPropagation();
          } 
       },
      
        getNewFeedURL: function(options) {       
     
           var host = options.env == 'prod' ? 'http://www.mlb.com' : (options.env == 'beta' ? 'http://beta.mlb.com' : '');
           var prefix = (window.location.href.indexOf("qa.mlb.com") > -1) ? "qa-" : "";
           var path = host; 
           var url = "";
           var game_pk = options.gpk;
           var baseUrl = "http://"+prefix+"statsapi.mlb.com/api/v1/game/";

           url = baseUrl+options.gpk+"/feed/color";
           return url;
          
        }
    }
    return Utils;
})
;
